module.exports = __webpack_public_path__ + "static/media/154.c3846a0b.webp";